import { CenteredSquaredContainer } from '@drycut/ui-components';
import { twMerge } from 'tailwind-merge';

type Props = {
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
};

export function Container({ children, className, wrapperClassName }: Props): React.ReactElement {
  const classes = twMerge('p-10 lg:p-10 min-w-full', className);

  // Most screens are narrow cards. The ones that need the full width (the booking checkout) opt out
  // with `max-w-none w-auto`.
  const wrapperClasses = twMerge('min-h-0 lg:min-h-0 m-0 max-w-lg mx-10', wrapperClassName);

  return (
    <CenteredSquaredContainer wrapperClassName={wrapperClasses} className={classes}>
      {children}
    </CenteredSquaredContainer>
  );
}
